import { FC } from 'react';
import { MriRiskPanel } from './MriRiskPanel';

/**
 * Panneau « risque » de la contractualisation MRI : le récapitulatif de la copropriété
 * (le même qu'en tarification), modifiable section par section dans des sous-panneaux.
 * Point d'entrée seul — le contenu vit dans MriRiskPanel.
 */
export const MriRisk: FC = () => <MriRiskPanel />;
